import { Directive, effect, ElementRef, inject, input } from '@angular/core';
import { FieldState, FieldTree } from '@angular/forms/signals';

@Directive({
  selector: '[libInputFieldValidity]',
})
export class LibInputFieldValidity<T> {
  private el = inject(ElementRef);
  public libInputFieldValidity = input.required<FieldTree<T>>();

  constructor() {
    effect(() => {
      const fieldTree: FieldTree<T> = this.libInputFieldValidity();
      const state: FieldState<T> = fieldTree();

      if (state.errors().length && state.touched()) {
        this.el.nativeElement.classList.add('error');
      } else {
        this.el.nativeElement.classList.remove('error');
      }
    });
  }
}
